import { normalizeKoreanMobile } from "./phone";

export type EmployeeCsvRow = {
  name: string;
  email: string;
  phone: string;
  organization: string;
  defaultLocation: string;
};

const EMPLOYEE_HEADERS = ["이름", "이메일", "휴대폰번호", "소속", "기본식사장소"];

function parseRows(text: string): string[][] {
  const rows: string[][] = [];
  let row: string[] = [];
  let field = "";
  let quoted = false;
  const source = text.replace(/^\ufeff/, "");

  for (let index = 0; index < source.length; index += 1) {
    const character = source[index];
    if (character === '"') {
      if (quoted && source[index + 1] === '"') {
        field += '"';
        index += 1;
      } else {
        quoted = !quoted;
      }
    } else if (character === "," && !quoted) {
      row.push(field.trim());
      field = "";
    } else if ((character === "\n" || character === "\r") && !quoted) {
      if (character === "\r" && source[index + 1] === "\n") index += 1;
      row.push(field.trim());
      if (row.some(Boolean)) rows.push(row);
      row = [];
      field = "";
    } else {
      field += character;
    }
  }

  row.push(field.trim());
  if (row.some(Boolean)) rows.push(row);
  return rows;
}

function csvValue(value: string): string {
  return /[",\r\n]/.test(value) ? `"${value.replaceAll('"', '""')}"` : value;
}

export function employeeCsvTemplate(organization = "병원", defaultLocation = "신사본관"): string {
  return [EMPLOYEE_HEADERS.join(","), ["홍길동", "hong@example.com", "010-0000-0000", organization, defaultLocation].map(csvValue).join(",")].join("\r\n");
}

export function parseEmployeeCsv(text: string): EmployeeCsvRow[] {
  const [headers, ...rows] = parseRows(text);
  if (!headers || EMPLOYEE_HEADERS.some((header, index) => headers[index]?.replaceAll(" ", "") !== header)) {
    throw new Error("닥터스 CSV 양식의 열 이름을 그대로 사용해 주세요.");
  }
  const parsed = rows.map((values) => ({
    name: values[0]?.trim() ?? "",
    email: values[1]?.trim().toLowerCase() ?? "",
    phone: normalizeKoreanMobile(values[2]?.trim() ?? "") ?? (values[2]?.trim() ?? ""),
    organization: values[3]?.trim() ?? "",
    defaultLocation: values[4]?.trim() ?? "",
  })).filter((row) => Object.values(row).some(Boolean));
  if (!parsed.length) throw new Error("등록할 직원이 없습니다.");
  return parsed;
}
